/**
 * ============================================================
 * 한국어
 * ============================================================
 *
 * Translators:
 *
 * Lee Yunseok <ironyunseok@protonmail.com>
 */



export default {
	'AdvanceHelp': '게임을 진행하려면 게임 화면을 좌클릭 또는 탭하거나 스페이스 키를 누르세요',
	'AllowPlayback': '오디오 재생을 허용하려면 여기를 클릭하세요',
	'Audio': '오디오',
	'AutoPlay': '자동재생',
	'AutoPlayButton': '자동재생단추',
	'AutoPlaySpeed': '자동재생 속도',

	'Back': '되감기',
	'BackButton': '이전 지문 보기',

	'Cancel': '취소',
	'Close': '닫기',
	'Confirm': '종료하시겠어요?',
	'Credits': '만든이',

	'Delete': '삭제',
	'DialogLogButton': '대사록 보기',

	'FullScreen': '전체화면',

	'Gallery': '갤러리',

	'Help': '도움말',
	'Hide': '숨기기',
	'HideButton': '지문 창을 숨깁니다',

	'iOSAudioWarning': '오디오 설정은 iOS에서 지원되지 않습니다',

	'KeyboardShortcuts': '키보드 단축키',

	'Language': '언어',
	'Load': '불러오기',
	'LoadAutoSaveSlots': '자동저장된 게임',
	'LoadButton': '불러오기 화면 열기',
	'Loading': '불러오는 중',
	'LoadingMessage': '자산을 불러오는 동안 기다려주세요',
	'LoadSlots': '저장된 게임',
	'LocalStorageWarning': '로컬 저장소는 이 브라우저에서 사용 불가능합니다',
	'Log': '대사록',

	'Music': '음악 음량',

	'NewContent': '페이지를 새로고침하는 것으로 최신 버전의 새로운 콘텐츠를 사용 가능할 수 있습니다',
	'NoSavedGames': '저장된 게임이 없습니다',
	'NoAutoSavedGames': '자동으로 저장된 게임이 없습니다',
	'NoDialogsAvailable': '대화 상자를 사용할 수 없습니다. 사용할 수 있게 되면 여기에 대화 상자가 나타납니다',

	'OK': '확인',
	'OrientationWarning': '플레이를 위해 기기를 회전해주세요',
	'Overwrite': '덮어쓰기',

	'QuickButtons': '빠른 메뉴 단추',
	'QuickMenu': '빠른 메뉴',
	'Quit': '종료',
	'QuitButton': '게임 종료',

	'Resolution': '해상도',

	'Save': '저장하기',
	'SaveButton': '저장 화면을 엽니다',
	'SaveInSlot': '슬롯에 저장',
	'SelectYourLanguage': 'Select your language',
	'Settings': '설정',
	'SettingsButton': '설정 화면을 엽니다',
	'Show': '보이기',
	'Skip': '넘기기',
	'SkipButton': '넘기기 모드 사용',
	'SlotDeletion': '이 슬롯을 삭제하시겠어요?',
	'SlotOverwrite': '이 슬롯에 덮어쓰시겠어요?',
	'Sound': '음향 음량',
	'Start': '시작',
	'Stop': '중지',

	'TextSpeed': '글자 속도',

	'Video': '비디오 음량',
	'Voice': '음성 음량',

	'Windowed': '창 화면'
};